<template>
    <div>
        <header>
            <el-form :inline="true" class="demo-form-inline" label-width="100px" size="small">
                <el-form-item label="字典类型查询" >
                    <el-input clearable v-model="condition" placeholder="请输入字典类型"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getData" style="flex-wrap: nowrap; ">查询</el-button>
                    <el-button v-if="rolePermission === '领导'" type="success" @click="update">增加</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
                <el-table :data="list" height="calc(100vh - 136px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                    min-width="30px" style="font-size: 14px;  margin-top: 0px;" size="mini">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="字典类型" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.typeName }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button>
                            <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            <!-- 添加字典类型弹框 -->
            <div>
                <el-dialog title="添加字典类型" :show-close="false" :close-on-click-modal="false" fullScreen
                    :visible.sync="dialogFormVisible">
                    <el-form>
                        <el-form-item required label="字典类型">
                            <el-input v-model="type" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirmChange">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    name: 'dictionaryType',
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            condition: '',
            list: [],
            dialogFormVisible: false,
            type: '',

        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        rowStyle() {
            return "text-align:center";
        },
        // 查询任务列表
        getData() {
            // this.currentPage = page;
            let URL = `${url.getDicTypeList}/?name=${this.condition}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data;
                }
            })
        },
        update() {
            this.dialogFormVisible = true;
        },
        confirmChange() {
            if (this.type == '') {
                this.$message({
                    type: 'error',
                    message: '请输入字典类型'
                })
            } else {
                let URL = `${url.addDicType}/?name=${this.type}`;
                req.post(URL).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '新增成功'
                        })
                        this.getData();
                        this.type = '';//情空
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })
            }

        },
        cancel() {
            this.dialogFormVisible = false;
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep .el-form-item {
    margin-bottom: 10px;
}
</style>